import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Checkbox, Group, Modal, Stack, TextInput } from '@mantine/core';

interface ExpiryDialogProps {
  readonly opened: boolean;
  readonly initial: { expiredDate?: string; isPerpetual?: boolean } | null;
  readonly loading?: boolean;
  readonly onSave: (isPerpetual: boolean, expiredDate?: string) => void;
  readonly onClose: () => void;
}

// Установка срока действия документа: дата «действует до» или «бессрочно».
export default function ExpiryDialog({ opened, initial, loading, onSave, onClose }: ExpiryDialogProps) {
  const { t } = useTranslation();
  const [perpetual, setPerpetual] = useState(false);
  const [date, setDate] = useState('');

  useEffect(() => {
    if (opened) {
      setPerpetual(!!initial?.isPerpetual);
      setDate(initial?.expiredDate?.slice(0, 10) ?? '');
    }
  }, [opened, initial]);

  const valid = perpetual || /^\d{4}-\d{2}-\d{2}$/.test(date);

  return (
    <Modal opened={opened} onClose={onClose} centered title={t('app.company.accreditation.expiry.title')}>
      <Stack gap="md">
        <TextInput
          type="date"
          label={t('app.company.accreditation.expiry.until')}
          value={date}
          disabled={perpetual}
          onChange={(event) => setDate(event.currentTarget.value)}
        />
        <Checkbox
          label={t('app.company.accreditation.expiry.perpetual')}
          checked={perpetual}
          onChange={(event) => setPerpetual(event.currentTarget.checked)}
        />
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button disabled={!valid} loading={loading} onClick={() => onSave(perpetual, perpetual ? undefined : date)}>
            {t('app.profile.save')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
